<template>
  <div>
    <v-dialog
      v-model="informativeDialog"
      content-class="informative-dialog-container"
      persistent
      :max-width="isMobile ? '90dvw' : '560px'"
    >
      <v-card class="informative-dialog-card">
        <div class="card-inner">
          <v-icon class="card-close" color="black" @click.stop="closeDialog">{{
            icons.mdiClose
          }}</v-icon>
          <v-card-text class="dialog-info">
            <strong class="header-text">What is next?</strong>
            <span class="subheader-text">Product refinement and purchase</span>
            <p>
              To provide you with an
              <strong class="paragraph-bold"
                >improved estate planning experience</strong
              >
              you are being redirected to the Different Life platform to
              finalise your product selection and purchase.
            </p>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mdiClose } from '@mdi/js';
  export default {
    name: 'InformativeDialog',
    components: {},
    props: {
      informativeDialog: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        icons: {
          mdiClose: mdiClose,
        },
      };
    },
    computed: {
      isMobile() {
        return this.$isMobileDevice();
      },
    },
    methods: {
      closeDialog() {
        this.$emit('informativeDialog');
      },
    },
  };
</script>

<style scoped lang="scss">
  .informative-dialog-container {
    .informative-dialog-card {
      position: relative;
      .card-close {
        position: absolute;
        top: 30px;
        right: 30px;
      }
      .card-inner {
        display: flex;
        flex-direction: column;
        padding: 74px 30px 40px 30px;

        .dialog-header {
          font-size: 22px;
          font-weight: 600;
          line-height: 26.82px;
          margin-bottom: 16px;
        }

        .dialog-info {
          padding: 0;
          .header-text {
            font-size: 20px;
            font-weight: 700;
            line-height: 22px;
            color: #ed0080;
            display: block;
          }
          .subheader-text {
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            display: block;
          }

          p {
            padding-top: 30px;
            font-size: 22px;
            font-weight: 400;
            line-height: 26px;

            .paragraph-bold {
              font-weight: 500;
            }
          }
        }
      }
    }
  }
</style>
